module.exports = __webpack_public_path__ + "img/公司官网_解决方案-公安-手机端.9b5d7299.png";